import { render, staticRenderFns } from "./SubtitleTranslation.vue?vue&type=template&id=fe8ec788"
import script from "./SubtitleTranslation.vue?vue&type=script&lang=js"
export * from "./SubtitleTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports